import React from 'react';
import { HorseCardComponentProps } from './HorseCard.types';
import { isInPlay, isPrePlay, isResulted, isSelectionMade, isWin } from './HorseCard.functions';
import { HorseCardColumn1, HorseCardColumn2, HorseCardEvent } from './HorseCard.components';
import GradientBorder from '../GradientBorder/GradientBorder';
import './HorseCard.scss';
import { useTranslation } from 'react-i18next';

const HorseCard = (props: HorseCardComponentProps) => {
  const { t } = useTranslation();
  const isReplaced = isResulted(props) && props.position === 'NR';
  const selected = isSelectionMade(props);
  const prePlay = isPrePlay(props);

  if ('raceName' in props) {
    return (
      <GradientBorder name={`horse`}>
        <div className={`horse-card horse-card__${props.state}`}>
          <HorseCardEvent eventInfo={{ name: props.raceName }} />
          <div className={'horse-card__abandoned-text'}>{t('abandoned')}</div>
        </div>
      </GradientBorder>
    );
  }

  const updated = selected ? props.updated : undefined;
  // in the designs updated uses the active state styles
  let stateClass = `${props.state}${updated ? '__focused' : ''}`;
  if (props.horseInfo.nonRunner && props.state === 'focused') {
    stateClass = '';
  }
  const win = isWin(props);
  const inPlay = isInPlay(props);
  const nonRunnerClass = props.horseInfo.nonRunner ? 'non-runner' : '';

  return (
    <GradientBorder name={`horse horse__${stateClass} ${win ? 'win' : ''} ${nonRunnerClass}`}>
      <div className={`horse-card horse-card__${stateClass} ${win ? 'win' : ''} ${nonRunnerClass}`}>
        {(!prePlay || selected) && <HorseCardEvent eventInfo={props.eventInfo} />}
        <div className={'horse-card-row'}>
          <HorseCardColumn1 state={props.state} horseInfo={props.horseInfo} replaced={isReplaced} />
          {!(props.horseInfo.nonRunner && props.state === 'not-focused') && (
            <HorseCardColumn2
              state={props.state}
              position={props.state === 'resulted' ? props.position : undefined}
              odds={props.horseInfo.odds}
              onClick={prePlay ? props.onClick : undefined}
              updated={updated}
              raceStarTime={inPlay ? props.raceStartTime : undefined}
              raceNumber={inPlay ? props.raceNumber : undefined}
              win={win && !isReplaced}
              nonRunner={props.horseInfo.nonRunner}
            />
          )}
        </div>
        {isReplaced && (
          <div className={'horse-card-row'}>
            <HorseCardColumn1 state={props.state} horseInfo={props.replaced.horseInfo} />
            <HorseCardColumn2 state={props.state} position={props.replaced.position} win={win} />
          </div>
        )}
      </div>
    </GradientBorder>
  );
};
export default HorseCard;
